export default {
    namespaced: true,
    state: {
        selectedGender: null,
        selectedYear: null,
        selectedPart: null,
        selectedSubPart: null,
        availableSymptoms: null,
        additionalSymptoms: [],
        selectedSymptom: null,
        selectedAdditionalSymptoms: [],
        availableDiagnosis: null,
        selectedDisease: null,
        loadedDisease: null
    },
    mutations: {
        setSelectedGender(state, selectedGender) {
            state.selectedGender = selectedGender;
        },
        setSelectedPart(state, selectedPart) {
            state.selectedPart = selectedPart;
        },
        setSelectedYear(state, selectedYear) {
            state.selectedYear = selectedYear;
        },
        setSelectedSubPart(state, selectedSubPart) {
            state.selectedSubPart = selectedSubPart;
        },
        setAvailableSymptoms(state, availableSymptoms) {
            state.availableSymptoms = availableSymptoms;
        },
        setAdditionalSymptoms(state, additionalSymptoms) {
            state.additionalSymptoms = additionalSymptoms == null ? [] : additionalSymptoms;
        },
        setSelectedSymptom(state, selectedSymptom) {
            state.selectedSymptom = selectedSymptom;
        },
        setSelectedAdditionalSymptoms(state, selectedAdditionalSymptoms) {
            state.selectedAdditionalSymptoms = selectedAdditionalSymptoms == null ? [] : selectedAdditionalSymptoms;
        },
        setAvailableDiagnosis(state, availableDiagnosis) {
            state.availableDiagnosis = availableDiagnosis;
        },
        setSelectedDisease(state, selectedDisease) {
            state.selectedDisease = selectedDisease;
        },
        setLoadedDisease(state, loadedDisease) {
            state.loadedDisease = loadedDisease;
        }
    },
    actions: {
        reset(state) {
            state.selectedGender = null;
            state.selectedYear = null;
            state.selectedPart = null;
            state.selectedSubPart = null;
            state.availableSymptoms = null;
            state.additionalSymptoms = [];
            state.selectedSymptom = null;
            state.selectedAdditionalSymptoms = [];
            state.availableDiagnosis = null;
            state.selectedDisease = null;
            state.loadedDisease = null;
        }
    },
    getters: {
        displayAdditionalSymptoms(state) {
            var display = [];

            var contains = {};

            for (var i in state.selectedAdditionalSymptoms) {
                display.push({
                    selected: true,
                    item: state.selectedAdditionalSymptoms[i]
                });

                contains[state.selectedAdditionalSymptoms[i].Name] = true;
            }


            for (var i in state.additionalSymptoms) {
                if (contains[state.additionalSymptoms[i].Name] == true) {
                    continue;
                }

                display.push({
                    selected: false,
                    item: state.additionalSymptoms[i]
                });
            }


            display.sort(function (a, b) {
                if (a.item.Name > b.item.Name) {
                    return 1;
                }

                if (a.item.Name < b.item.Name) {
                    return -1;
                }

                return 0;
            });

            return display;
        }
    }
}